import { useState } from "react";
import { useDispatch } from "react-redux";
import useMerchantPortalAxios, {
  useMerchantPortalFormData,
} from "../../utils/axios";
import { setFlag } from "../../features/responseSlice";
import {
  setError as setAppError,
  setFeatureData,
  setTableData,
  setTableLoading,
} from "../store/slices/appSlice";

function base64ToFile(dataUrl, fileName) {
  if (!dataUrl) return null;

  const [meta, content] = String(dataUrl).split(",");
  if (!meta || !content) return null;

  const mimeType = meta.split(":")[1]?.split(";")[0] || "application/octet-stream";
  const byteCharacters = atob(content);
  const byteArray = new Uint8Array(byteCharacters.length);

  for (let index = 0; index < byteCharacters.length; index += 1) {
    byteArray[index] = byteCharacters.charCodeAt(index);
  }

  return new File([byteArray], fileName || "upload", {
    type: mimeType,
  });
}

export default function useNewMerchantInformationAPI() {
  const client = useMerchantPortalAxios();
  const formClient = useMerchantPortalFormData();
  const dispatch = useDispatch();
  const [merchantInformation, setMerchantInformation] = useState({});
  const [merchantLoading, setMerchantLoading] = useState(true);

  async function GetMerchantInformation() {
    setMerchantLoading(true);
    dispatch(setTableLoading({ key: "merchantInformation", loading: true }));
    dispatch(setAppError(null));

    try {
      const response = await client.post("/v1/MerchantInformation/GetMerchantInformation", {
        SessionID: sessionStorage.getItem("SessionID"),
      });

      const payload = response?.data?.Payload || {};
      setMerchantInformation(payload);
      dispatch(
        setFeatureData({
          section: "details",
          key: "merchantInformation",
          value: payload,
        }),
      );
      dispatch(
        setTableData({
          key: "merchantInformation",
          data: Array.isArray(payload?.MerchantsInfoList)
            ? payload.MerchantsInfoList
            : [],
          pagination: {
            page: 1,
            totalPages: 1,
            totalCount: Array.isArray(payload?.MerchantsInfoList)
              ? payload.MerchantsInfoList.length
              : 0,
          },
        }),
      );
      return payload;
    } catch (error) {
      dispatch(
        setTableData({
          key: "merchantInformation",
          data: [],
          pagination: {
            page: 1,
            totalPages: 0,
            totalCount: 0,
          },
        }),
      );
      dispatch(
        setAppError(
          error?.response?.data?.Message ||
            error?.response?.data?.message ||
            "Unable to load merchant information right now.",
        ),
      );
      throw error;
    } finally {
      setMerchantLoading(false);
      dispatch(setTableLoading({ key: "merchantInformation", loading: false }));
    }
  }

  async function EditMerchantInfo(payload) {
    const nextPayload = {
      ...payload,
      NewLogoImage: payload?.NewLogoImage
        ? base64ToFile(payload.NewLogoImage, payload.NewLogoImageName)
        : payload?.NewLogoImage,
      NewCoverImage: payload?.NewCoverImage
        ? base64ToFile(payload.NewCoverImage, payload.NewCoverImageName)
        : payload?.NewCoverImage,
    };

    const response = await formClient.post(
      "/v1/MerchantInformation/EditMerchantInfo",
      nextPayload,
    );

    return response?.data?.Payload;
  }

      async function ManageAutoExchange(payload) {
        const res = await client.post(
            "/v1/MerchantInformation/ManageAutoExchange",
            payload
        );
        return res;
    }

  async function EditPaymentConfig(merchantId, paymentConfig) {
    const response = await client.post("/v1/MerchantInformation/EditPaymentConfig", {
      SessionID: sessionStorage.getItem("SessionID"),
      MerchantAccountID: merchantId,
      PaymentConfig: paymentConfig,
    });

    dispatch(setFlag(1));
    dispatch(
      setFeatureData({
        section: "ui",
        key: "merchantInformation",
        value: {
          lastEditedMerchantId: merchantId,
          paymentConfig,
        },
      }),
    );
    return response?.data?.Payload;
  }

  return {
    GetMerchantInformation,
    EditMerchantInfo,
    EditPaymentConfig,
    ManageAutoExchange,
    merchantInformation,
    merchantLoading,
  };
}
